/*!
 * beDate Jquery plugin:
 * Plugin para la selección de pais, provincia y ciudad
 * Author: @pablocrs
 */

;(function ($, window, document, undefined) {


    // Create the defaults once
    var pluginName = 'beAnnex',
        defaults = {
            agreementSelect: '.js-beAnnex--agreement',
            jobOffserSelect: '.js-beAnnex--job-offer',
            candidateSelect: '.js-beAnnex--student',
            apiUrl: window.location.origin,
            locale: 'es'
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.selects = [
            this.$element.find(this.options.agreementSelect),
            this.$element.find(this.options.jobOffserSelect),
            this.$element.find(this.options.candidateSelect)
        ];

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        Plugin.setEvents();
        Plugin.loadSelect(Plugin.selects[0], 'gestion-de-convenios/convenios-marco/list');

        Plugin.selects[0].on('change', function () {
            Plugin.clearAll();
            var data = $(this).select2('data')[0];
            $.each(Plugin.selects, function (i, select) {
                if (i > 0) {
                    Plugin.selects[i].val('null').empty().trigger('change');
                }
            });
        });

        Plugin.selects[0].on('select2:unselect', function () {
            Plugin.clearAll();
            $.each(Plugin.selects, function (i, select) {
                Plugin.selects[i].val('null').empty().trigger('change');
            });
        });

        $.each(Plugin.selects, function (i, select) {
            if (i > 0) {
                if (!Plugin.selects[0].val()) {
                    Plugin.selects[i].prop('disabled', true).select2('data', null);
                }
            }
        });
    };
    Plugin.prototype.loadSelect = function (select, url) {
        var Plugin = this;

        var url = Plugin.options.apiUrl + '/' + url;
        select.select2('data', null);

        select.select2({
            allowClear: true,
            ajax: {
                url: url,
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {id: params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if (data.data) {
                        return {
                            results: $.map(data.data, function (item) {
                                 if(item.student_id > 0){
                                    return {
                                      text: item.name + ' (ID:' + item.student_id + ')',
                                      slug: item.locale,
                                      id: item.student_id
                                    }
                                 }
                                 return {
                                    text: item.name + ' (ID:' + item.id + ')',
                                    slug: item.locale,
                                    id: item.id,
                                    company_id: item.company_id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        if (select.data('selected')) {
            select.val(select.data('selected')).trigger('change');
        }
    };

    // Congfigura evento change en cada select
    //
    Plugin.prototype.setEvents = function () {
        var Plugin = this;

        $.each(Plugin.selects, function (i, selector) {
            $(selector).on('change', function (e) {
                Plugin.enableNext(i, Plugin.selects);
                console.log(this);
                Plugin.setJobOfferURL();
                Plugin.setAgreementURL();
                Plugin.setStudentURL();
            });
        });
    };

    /// Quita disabled del siguiente select del array
    //
    Plugin.prototype.enableNext = function (id, array) {
        var Plugin = this;

        var next = id + 1;

        if (array[next]) {

            if (next === 1) {
                array[next].prop('disabled', false);
                var data = $(Plugin.selects[0]).select2('data')[0];
                if(data.company_id == undefined) {
                    data = { company_id: Plugin.selects[0].data('company_id') };
                }
                Plugin.loadSelect($(array[next]), 'empresas/' + data.company_id + '/ofertas/list');
            }

            if (next === 2) {
                array[next].prop('disabled', false);
                if(array[1].val()) {
                  Plugin.loadSelect($(array[next]), 'ofertas/candidatos-elegidos/' + $(array[1]).val());
                  array[next].val('null').empty().trigger('change');
                } else {
                  Plugin.loadSelect($(array[next]), 'alumnos/list');
                }
            }

        }
    };

    Plugin.prototype.clearAll = function () {
        $.each(Plugin.selects, function (i, select) {
            if (i > 0) {
                Plugin.selects[i].select2('data', null);
                Plugin.selects[i].val(null).trigger('change');
                if (!Plugin.selects[i].val()) {
                    Plugin.selects[i].prop('disabled', true);
                }
            }
        });
    };

    Plugin.prototype.setJobOfferURL = function () {
        var selectedJobOfferId = $('.js-beAnnex--job-offer').val();
        if(selectedJobOfferId !== null){
            $('#js-beAnnex--job-offer-url-container').removeClass('hide');
            $('#js-beAnnex--job-offer-url').attr('href', this.options.apiUrl + '/ofertas/editar/' + selectedJobOfferId);
        }else {
            $('#js-beAnnex--job-offer-url-container').addClass('hide');
        }
    }

    Plugin.prototype.setAgreementURL = function () {
        var selectedAgreementId = $('.js-beAnnex--agreement').val();
        if(selectedAgreementId !== null){
            $('#js-beAnnex--agreement-url-container').removeClass('hide');
            $('#js-beAnnex--agreement-url').attr('href', this.options.apiUrl + '/gestion-de-convenios/convenios-marco/' + selectedAgreementId);
        }else {
            $('#js-beAnnex--agreement-url-container').addClass('hide');
        }
    }

    Plugin.prototype.setStudentURL = function () {
        var selectedStudentId = $('.js-beAnnex--student').val();
        if(selectedStudentId !== null){
            $('#js-beAnnex--student-url-container').removeClass('hide');
            $('#js-beAnnex--student-url').attr('href', this.options.apiUrl + '/alumnos/edit/' + selectedStudentId);
        }else {
            $('#js-beAnnex--student-url-container').addClass('hide');
        }
    }

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            }
        });
    }

})(jQuery, window, document);